import React from 'react';

interface NmMenuCardProps {
  children: React.ReactNode;
  className?: string;
}

export function NmMenuCard({ children, className = '' }: NmMenuCardProps) {
  return <div className={`nm-menu-card ${className}`.trim()}>{children}</div>;
}

interface NmMenuRowProps {
  label: string;
  description?: string;
  icon?: React.ReactNode;
  onClick: () => void;
  last?: boolean;
}

export function NmMenuRow({ label, description, icon, onClick, last }: NmMenuRowProps) {
  return (
    <button
      type="button"
      className="nm-menu-row"
      onClick={onClick}
      style={last ? { borderBottom: 'none' } : undefined}
    >
      {icon != null ? (
        typeof icon === 'string' ? (
          <span className="nm-menu-row__icon nm-menu-row__icon--neutral" aria-hidden>
            {icon}
          </span>
        ) : (
          icon
        )
      ) : null}
      <span style={{ flex: 1, minWidth: 0 }}>
        <div className="nm-menu-row__label">{label}</div>
        {description && <div className="nm-menu-row__desc">{description}</div>}
      </span>
      <span className="nm-menu-row__chevron" aria-hidden>›</span>
    </button>
  );
}

export function NmSectionLabel({ label }: { label: string }) {
  return <div className="nm-section-label">{label}</div>;
}

interface NmMenuPickRowProps {
  label: string;
  selected?: boolean;
  onClick: () => void;
  last?: boolean;
}

/** Single-choice row inside NmMenuCard (e.g. language picker). */
export function NmMenuPickRow({ label, selected = false, onClick, last }: NmMenuPickRowProps) {
  return (
    <button
      type="button"
      className={`nm-menu-row nm-menu-pick-row${selected ? ' nm-menu-pick-row--selected' : ''}`}
      onClick={onClick}
      style={last ? { borderBottom: 'none' } : undefined}
      aria-pressed={selected}
    >
      <span style={{ flex: 1, minWidth: 0 }}>
        <div className="nm-menu-row__label">{label}</div>
      </span>
      {selected && <span className="nm-menu-pick-row__check" aria-hidden>✓</span>}
    </button>
  );
}
